export default "__VITE_ASSET__BGyHJjOT__"